import { css } from '@linaria/core';
import { IconCoin } from 'components/Icons';
import { useFeatureFlagsLD } from 'modules/FeatureFlagsLD/FeatureFlagsProviderLD';
import { Link } from 'components/Link';
import { useCurrentUserId } from 'modules/Auth/hooks';
import { CreditBalance } from './CreditBalance';
type Props = {
  text?: string;
};
export const CreditChips = ({
  text = 'Credits:'
}: Props) => {
  const {
    creditsConfig
  } = useFeatureFlagsLD();
  const userId = useCurrentUserId();
  if (!creditsConfig || creditsConfig?.hide) {
    return null;
  }
  return <Link className={container} href={`/${userId}/settings/billing`}>
      <IconCoin size={20} />
      <CreditBalance text={text} />
    </Link>;
};
const container = "odules__User__components__Settings__Billing__CreditSummary__CreditChips_tsx-container-c1kptlkx";

require("./CreditChips.linaria.module.css!=!../../../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./CreditChips.tsx");